import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  AppBar, Box, Toolbar, IconButton, Typography, Menu, MenuItem,
} from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { getCurrentLanguage } from '../../utils/navigation';

const AuthNavbar = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [languageAnchorEl, setLanguageAnchorEl] = React.useState(null);

  const handleLanguageMenu = (event) => setLanguageAnchorEl(event.currentTarget);
  const handleLanguageClose = () => setLanguageAnchorEl(null);
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    handleLanguageClose();
  };

  return (
    <AppBar
      position="fixed" elevation={0}
      sx={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0', borderRadius: 0 }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
          onClick={() => navigate(`/${getCurrentLanguage()}`)}
        >
          <Box
            component="img" src="/images/lingoply-logo.jpg" alt="Lingoply"
            sx={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
          />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#F5A623', fontSize: '1.2rem', letterSpacing: '-0.02em' }}>
            Lingooply
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={handleLanguageMenu} size="small" sx={{ color: '#888', '&:hover': { color: '#F5A623' } }}>
            <LanguageIcon />
          </IconButton>
          <Menu
            anchorEl={languageAnchorEl} open={Boolean(languageAnchorEl)} onClose={handleLanguageClose}
            PaperProps={{ elevation: 2, sx: { minWidth: 120, mt: 1.5, borderRadius: '10px',
              '& .MuiMenuItem-root': { fontSize: '0.875rem', '&:hover': { backgroundColor: '#FFF8F0', color: '#F5A623' } }
            }}}
          >
            <MenuItem onClick={() => handleLanguageChange('ar')} selected={i18n.language === 'ar'}>العربية</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('en')} selected={i18n.language === 'en'}>English</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('fr')} selected={i18n.language === 'fr'}>Français</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AuthNavbar;
